/**
 * SIMPLIFIED AUTH0 SESSION TRANSFER ENTRY POINT
 *
 * Entry point for Auth0 flow. This saga:
 * 1. Checks if transfer already completed
 * 2. Checks if code in URL (from Auth0 callback)
 * 3. If code found → dispatch CAPTURE_AUTH0_CODE (Flow will extract it)
 * 4. If no code but transfer token → dispatch CAPTURE_AUTH0_CODE (Flow will redirect)
 * 5. Otherwise → exit (not an auth flow)
 */

import { put } from 'redux-saga/effects';

export const initializeAuth0SessionTransfer = function* (action) {
    try {
        // Exit if transfer already completed
        const transferCompleted = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('auth0_transfer_completed') === 'true';

        if (transferCompleted) {
            return;
        }

        // Mark transfer as started
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem('auth0_transfer_started', 'true');
        }

        // Check if authorization code in URL from Auth0 callback
        const authCodeInUrl = typeof window !== 'undefined' && (window.location.search.includes('code=') || window.location.search.includes('code=='));

        if (authCodeInUrl) {
            yield put({ type: 'CAPTURE_AUTH0_CODE' });
            return;
        }

        // Check for transfer token in session storage
        const hasSessionTransferToken = typeof sessionStorage !== 'undefined' && !!sessionStorage.getItem('auth0_session_transfer_token');

        if (!hasSessionTransferToken) {
            sessionStorage.removeItem('auth0_transfer_started');
            console.debug('[AUTH0] Not initiated - no code in URL and no transfer token');
            return;
        }

        // Initiate Auth0 code capture
        yield put({ type: 'CAPTURE_AUTH0_CODE' });
    } catch (error) {
        console.error('[AUTH0] Transfer error:', error?.message || error);
    }
};

// Export for saga listener registration
// eslint-disable-next-line func-style
export function* auth0SessionTransferSaga(action) {
    yield* initializeAuth0SessionTransfer(action);
}

export default [['SET_ROUTER_LOCATION'], auth0SessionTransferSaga];
